export const isTestContentLocation = !window.location.origin.includes('eyemanage.eyemedvisioncare.com')

export const contentUrl = () => {
  const environment = isTestContentLocation ? 'contentTEST' : 'contentPROD'
  return `https://content.eyemedvisioncare.com/${environment}/eyemanage/`
}
